export var Size = /*#__PURE__*/ function(Size) {
    Size["md"] = "md";
    Size["lg"] = "lg";
    return Size;
}({});
